__turbopack_context__.v({
  "card": "AntdTable-module-scss-module__cGk_Ma__card",
  "container": "AntdTable-module-scss-module__cGk_Ma__container",
  "header": "AntdTable-module-scss-module__cGk_Ma__header",
  "hoveredCard": "AntdTable-module-scss-module__cGk_Ma__hoveredCard",
  "mobileList": "AntdTable-module-scss-module__cGk_Ma__mobileList",
  "paginationArrow": "AntdTable-module-scss-module__cGk_Ma__paginationArrow",
  "paginationArrowPrev": "AntdTable-module-scss-module__cGk_Ma__paginationArrowPrev",
  "sectionTitle": "AntdTable-module-scss-module__cGk_Ma__sectionTitle",
  "table": "AntdTable-module-scss-module__cGk_Ma__table",
});
